<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Staff"
};
</script>

<style scoped>
</style>